// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"2a6f9696","250":"4375088e","488":"67597a26","627":"014fee12"}[chunkId] + ".chunk.js";
};